<template>
  <div class="setting-main-container">
    <form action="" @submit.prevent="submitBusinessData">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('profile.business_status.business_status') }}</h3>
        </div>
        <div class="row">
         
          <div class="col-md-6 mb-4">
            <label class="input-label">{{ $tc('profile.business_status.business_status') }}</label><span class="text-danger"> * </span>
            <base-select
              v-model="formData.status"
              :options="businessStatuses"
              :class="{'error': $v.formData.status.$error }"
              :searchable="true"
              :show-labels="false"
              :allow-empty="false"
              :placeholder="$t('profile.business_status.select_business_status')"
            />
            <div v-if="$v.formData.status.$error">
              <span v-if="!$v.formData.status.required" class="text-danger">{{ $tc('validation.required') }}</span>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <label class="input-label">{{ $tc('profile.business_status.business_nature') }}</label><span class="text-danger"> * </span>
            <base-select
              v-model="formData.nature"
              :options="businessNature"
              :class="{'error': $v.formData.nature.$error }"
              :searchable="true"
              :show-labels="false"
              :allow-empty="false"
              :placeholder="$t('profile.business_status.select_business_nature')"
            />
            <div v-if="$v.formData.nature.$error">
              <span v-if="!$v.formData.nature.required" class="text-danger">{{ $tc('validation.required') }}</span>
            </div>
          </div>
          <div class="col-md-12 mb-4">
            <label class="input-label">{{ $tc('profile.business_status.annual_sales_turnover') }}</label><span class="text-danger"> * </span>
             <base-input
                type="numeric"
                v-model="formData.annual_sales_turnover" 
                @input="$v.formData.annual_sales_turnover.$touch()"           
              />
            <div v-if="$v.formData.annual_sales_turnover.$error">
              <span v-if="!$v.formData.annual_sales_turnover.required" class="text-danger">{{ $tc('validation.required') }}</span>
              <span v-if="!$v.formData.annual_sales_turnover.numeric" class="text-danger">{{ $tc('validation.numbers_only') }}</span>
            </div>
          </div>
           <div class="col-md-12 mb-4">
            <label class="input-label">{{ $tc('profile.business_status.num_employee_including_contract') }}</label><span class="text-danger"> * </span>
             <base-input
                v-model="formData.total_employees" 
                @input="$v.formData.total_employees.$touch()"           
              />
            <div v-if="$v.formData.total_employees.$error">
              <span v-if="!$v.formData.total_employees.required" class="text-danger">{{ $tc('validation.required') }}</span>
              <span v-if="!$v.formData.total_employees.numeric" class="text-danger">{{ $tc('validation.numbers_only') }}</span>
            </div>
          </div>
                       
        </div>
        <div class="row">
          <div class="col-md-12">
            <p class="text-danger"> {{ $tc('profile.business_status.contact_note') }}</p>
            <base-button
              :loading="isLoading"
              :disabled="isLoading"
              icon="save"
              color="theme"
              type="submit"
            >
              {{ $tc('profile.business_status.save') }}
            </base-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import IconUpload from '../../components/icon/upload'
import { validationMixin } from 'vuelidate'
import { mapActions,mapGetters } from 'vuex'
const { required, email, maxLength, numeric } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
        formData : {
            id:null,
            status:null,
            nature:null,
            annual_sales_turnover:null,
            total_employees:null,
        },
        businessStatuses: [ 'Sole Proprietorship','Partnership','Public Limited Company','Private Limited Company','AOP','Other'],
        businessNature:['Industrial','Commercial','Agricultural','Services','Other'],
        isLoading: false,
    }
  },
  computed: {
    ...mapGetters('business', [
      'business'
    ]),
   
  }, 
  created() {
       if(this.business){
            this.formData.id=this.business.id
      }  
      if(this.business && this.business.status){
          this.formData.status=this.business.status
      }
      if(this.business && this.business.nature){
        this.formData.nature=this.business.nature
      }
      if(this.business && this.business.annual_sales_turnover){
        this.formData.annual_sales_turnover=this.business.annual_sales_turnover
      }
      if(this.business && this.business.total_employees){
        this.formData.total_employees=this.business.total_employees
      }
      
  },
  validations: {
    formData: {
      status: {
        required
      },
      nature:{
        required
      },
      annual_sales_turnover:{
        required, numeric
      },
      total_employees:{
        required,numeric
      }
    }
  },
  mounted () {
   
  },
  methods: {
      ...mapActions('business', [
      'addBusiness',
      'updateBusiness'
    ]),    
    async submitBusinessData () {
        this.$v.formData.$touch()
        if (this.$v.$invalid) {
            return true
        }
        let  response =await this.addBusiness(this.formData)
        if (response.data) { 
            this.isLoading = false
            window.toastr['success'](this.$tc('profile.business_status.saved_message'))
            return true
        } 
    },
  }
}
</script>
